// Converte coordinate client (mouse/touch) in coordinate viewBox di un SVG
export const clientToSvg = (svg, clientX, clientY) => {
  if (!svg) return { x: 0, y: 0 };
  const pt = svg.createSVGPoint();
  pt.x = clientX;
  pt.y = clientY;
  const inv = svg.getScreenCTM().inverse();
  const p = pt.matrixTransform(inv);
  return { x: p.x, y: p.y };
};